import { getActivePinia, type Pinia } from 'pinia'

/**
 * Resetea TODOS los stores Pinia a su estado inicial.
 *
 * Se usa al cerrar sesión y al detectar un cambio de usuario autenticado
 * (login de otra cuenta en otra pestaña, sesión expirada) para evitar que
 * datos cacheados de una sesión —p. ej. la lista de procedimientos o el
 * caché `lastFetch*`— se filtren/queden visibles para el siguiente usuario.
 */
export function resetAllStores(pinia: Pinia | null = getActivePinia() ?? null) {
  if (!pinia) return
  // `_s` es el Map interno de stores activos de Pinia.
  ;(pinia as any)._s.forEach((store: any) => {
    // Cerrar canales Realtime ANTES de $reset(): $reset pone los refs de canal
    // en su estado inicial (null) sin llamar removeChannel, dejando la
    // suscripción viva y huérfana (fuga de websocket en cada logout / cambio de
    // usuario). unsubscribe() de cada store hace removeChannel y limpia el ref.
    if (typeof store.unsubscribe === 'function') {
      try { store.unsubscribe() } catch { /* best-effort teardown */ }
    }
    if (typeof store.$reset === 'function') store.$reset()
  })
}
